import { ImageInfo } from "../common/ImageInfo";
import './Donate.css';
import { DonateForm } from './DonateForm';
import { PageInfo } from '../common/PageInfo';

export function Donate() {
  return (
    <div>
      <ImageInfo pageId={4} />
      <PageInfo pageId={4} />
      <DonateForm />
    </div>
  );
}
